import * as yup from 'yup';

import { StatusBadge } from '@components';

export const typeOptions = [
  {
    value: 'Online',
    label: <StatusBadge label="Online" />,
  },
  {
    value: 'Offline',
    label: <StatusBadge label="Offline" />,
  },
  {
    value: 'Decommissioned',
    label: <StatusBadge label="Decommissioned" />,
  },
];

export const formSchema = yup
  .object({
    name: yup.string().required(),
    description: yup.string().nullable(),
    type: yup.string().required(),
    isDefault: yup.boolean(),
  })
  .required();
